/**
 * @author liqingbo
 * @version 1.6.0
 */

const { wx: wxsdk } = window as any;

// 微信api列表 官方文档里给的不全自行补充过的
const API_LIST = [
  'startSearchBeacons',
  'stopSearchBeacons',
  'ready',
  'error',
  'config',
  'checkJsApi',
  'getLocalImgData',
  'onSearchBeacons',
  'openAddress',
  'updateAppMessageShareData',
  'updateTimelineShareData',
  'onMenuShareTimeline',
  'onMenuShareAppMessage',
  'onMenuShareQQ',
  'onMenuShareWeibo',
  'onMenuShareQZone',
  'startRecord',
  'stopRecord',
  'onVoiceRecordEnd',
  'playVoice',
  'pauseVoice',
  'stopVoice',
  'onVoicePlayEnd',
  'uploadVoice',
  'downloadVoice',
  'chooseImage',
  'previewImage',
  'uploadImage',
  'downloadImage',
  'translateVoice',
  'getNetworkType',
  'openLocation',
  'getLocation',
  'hideOptionMenu',
  'showOptionMenu',
  'hideMenuItems',
  'showMenuItems',
  'hideAllNonBaseMenuItem',
  'showAllNonBaseMenuItem',
  'closeWindow',
  'scanQRCode',
  'chooseWXPay',
  'openProductSpecificView',
  'addCard',
  'chooseCard',
  'openCard',
];

const wx = Object.keys(wxsdk).reduce(function(total: any, api) {
  if (!API_LIST.includes(api)) {
    total[api] = wxsdk[api];
  } else {
    total[api] = function(options: any = {}) {
      const _this = wxsdk;
      return new Promise(function(res, rej) {
        if (api === 'config') {
          wxsdk.config.call(_this, options);
          wxsdk.ready.call(_this, res);
          wxsdk.error.call(_this, rej);
          return;
        }

        if (api === 'ready') {
          wxsdk[api].call(_this, res);
          return;
        }

        if (api === 'error') {
          wxsdk[api].call(_this, rej);
          return;
        }

        wxsdk[api].call(_this, {
          ...options,
          // 只重写success和fail cancel complete按原来的用
          success: res,
          fail: rej,
        });
      });
    };
  }

  return total;
}, {});

export default wx;
